@if (timeformSpotlightDisplay) {
    <div>
        <div class="timeformtip-header">
            <div class="timeformtip-logo left"></div>
            <div class="left">{{ sitecore.horseRacing.raceDetails.SpotlightTitle }}</div>
        </div>
        <table class="timeform-spotlight">
            <tbody>
                <tr>
                    @for (spotlightIndex of timeformSpotlightIndexes; track spotlightIndex; let index = $index) {
                        <td>
                            <div>{{ index + 1 }}. {{ runners[spotlightIndex].name | msTranslate }}</div>
                            <ms-star-rating [rating]="runners[spotlightIndex].timeformInfo?.ratingStars" />
                        </td>
                    }
                </tr>
            </tbody>
        </table>
    </div>
}
